
import { Component } from '@angular/core';

import { NominationProposalDto } from '@models/votes/nomination-proposal.dto';
import { NominationStatus } from '@models/votes/nomination-type.enum';

import { MessageService } from '@services/message.service';
import { NominationService } from '@services/nomination.service';

@Component({
  selector: 'ebs-view-nomination',
  templateUrl: './view-nomination.component.html',
  styleUrls: ['./view-nomination.component.scss'],
})
export class ViewNominationComponent {
  public showConfirmation: boolean = false;
  public loaded: boolean = false;

  public nominations: NominationProposalDto[] = [];
  public NominationStatus: typeof NominationStatus = NominationStatus;

  public confirming: NominationProposalDto | undefined;

  constructor(
    public nominationService: NominationService,
    private messageService: MessageService,
  ) {
    this.loadNominations();
  }

  loadNominations() {
    this.nominationService.getAvailableProposalList().subscribe((result) => {
      this.loaded = true;
      this.nominations = result;
    });
  }

  showConfirm(proposal: NominationProposalDto) {
    this.confirming = proposal;
    this.showConfirmation = true;
  }

  submit(nomination: NominationProposalDto) {
    this.nominationService
      .submitNomination(nomination.proposalId!)
      .subscribe(() => {
        this.messageService.success(
          'Candidatura spontanea',
          'Candidatura spontanea inviata',
        );

        this.showConfirmation = false;
        this.confirming = undefined;

        this.loadNominations();
      });
  }

  cancel() {
    this.showConfirmation = false;
    this.confirming = undefined;
  }
}
